import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'IS THIS A PHYSICAL OR DIGITAL PRODUCT?',
  answer: 'Basketball Ready: System 365 is a 100% digital product delivered instantly in PDF format.\n\nYou can access it instantly from your PC, Mac, tablet, or smartphone, and it is fully printable.'
}, {
  question: 'DO I NEED ADVANCED COACHING EXPERIENCE TO USE IT?',
  answer: 'No.\n\nThe system is built for both newer and experienced basketball coaches. Every volume is organized step-by-step, so you can implement practices immediately.'
}, {
  question: 'CAN I PRINT THE MATERIALS?',
  answer: 'Yes.\n\nYou can print any volume, practice plan, coaching framework, or bonus for your personal coaching use.'
}, {
  question: 'ARE THE BONUSES REALLY INCLUDED FOR USD 27?',
  answer: 'Yes.\n\nAll 5 premium bonuses are included FREE when you purchase Basketball Ready: System 365 today for USD 27.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-navy-800 bg-navy-950 py-12 md:py-20" data-id="element-40">
      <div className="container mx-auto px-4" data-id="element-41">
        <div className="mb-10 text-center md:mb-16" data-id="element-42">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-3xl uppercase tracking-wide text-white sm:text-4xl md:text-5xl" data-id="element-43">
            FREQUENTLY ASKED QUESTIONS
          </motion.h2>
        </div>

        <div className="mx-auto max-w-3xl space-y-3 md:space-y-4" data-id="element-44">
          {faqs.map((faq, index) => <motion.div key={faq.question} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="overflow-hidden rounded-xl border border-navy-800 bg-navy-900" data-id="element-45">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between p-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 md:px-6 md:py-5" aria-expanded={openIndex === index} data-id="element-46">
                <span className="min-w-0 pr-3 font-oswald text-base uppercase leading-5 tracking-normal text-white md:pr-8 md:text-xl md:tracking-wide" data-id="element-47">
                  {faq.question}
                </span>
                <ChevronDown className={`h-5 w-5 flex-shrink-0 text-gold-500 transition-transform duration-300 md:h-6 md:w-6 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>

              <AnimatePresence data-id="element-49">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-50">
                    <div className="whitespace-pre-line p-4 pt-0 text-sm leading-6 text-gray-400 md:px-6 md:pb-6 md:text-base" data-id="element-51">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}